import { render, staticRenderFns } from "./root.vue?vue&type=template&id=a3eda6b6&scoped=true&"
import script from "./root.vue?vue&type=script&lang=js&"
export * from "./root.vue?vue&type=script&lang=js&"
import style0 from "./root.vue?vue&type=style&index=0&id=a3eda6b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3eda6b6",
  null
  
)

export default component.exports